import { Component, OnInit } from '@angular/core'
import { DataPageOfDocument, Category, UiPreferences } from '../../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { AppSettingService, DocumentService } from '../../../../../api/services'
import { MessageService, ConfirmationService } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { Customsort } from '../../../../directives/customsort'
import { DomSanitizer } from '@angular/platform-browser'
import { environment } from '../../../../../../environments/environment'
import { DatePipe } from '@angular/common'
import { SelectedPatientService } from '../../patient-list/patient-service'
import { combineLatest, timeoutWith } from 'rxjs'
import { CareFinitySession } from '../../../../services/CareFinitySession'
import { getLabelAndCount } from 'src/app/carefinity/services/docUtils'

@Component({
  selector: 'app-cat-document',
  templateUrl: './cat-document.component.html',
  styleUrls: ['./cat-document.component.css'],
})
export class CatDocumentComponent implements OnInit {
    Item = 'Documents'
    distinctCatList: Array<Category> = [{ categoryId: "", categoryName:"All" }]
  distinctcatresult: any
  arrdocdetails: DataPageOfDocument
  User: any
  imageHeader: string = ''
  rows: number
  private cols: any[]
  gridHeader: string = ''
  displaypopup: boolean = false
  pdfSrc: any
  href: string
  visible: boolean
  activeItem
    selectedCategoryId: any;
    preferences: UiPreferences = {};
    txtSearch: string = ''
    isSearchEnable: boolean = false;
    first = 0;

    setPrintFlag: boolean = false;
    currentUrl
    enableDownloads: boolean=false
  constructor(
    private selectedPatientService: SelectedPatientService,
    private fb: UntypedFormBuilder,
    private docservice: DocumentService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private datePipe: DatePipe,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private cstsort: Customsort,
    protected sanitizer: DomSanitizer,
      private appSettingsService: AppSettingService,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: 'visitDate', header: 'Visit Date' },
      { field: 'description', header: 'Description' },
      { field: 'createdbyName', header: 'Created By' },
      { field: 'createdOn', header: 'Create Date' },
      { field: 'format', header: 'Format' },
      ]

      this.currentUrl = this.router.url;
      console.log("current url is",this.currentUrl)

      this.LoaddistinctImageList();

     

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.documents || 'Documents';
      }


      this.appSettingsService
          .appSettingGetPracticeSettings$Response()
          .subscribe((res) => {
              if (CareFinitySession?.user.roles.patientRecordsPrint == true && res.body.enablePatientDemographicPrint == true) {
                  this.setPrintFlag = true;
              }
              else {
                  this.setPrintFlag = false;
              }
              this.enableDownloads = res.body.enableDocumentDownloads && CareFinitySession?.user.roles.enableDocumentDownloads;

          })


  }
  LoaddistinctImageList(): void {
    this.docservice
      .documentGetcategorylistbypatient({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
        .subscribe((result) => {
            this.distinctCatList = [...this.distinctCatList, ...result];

             this.distinctCatList = this.distinctCatList.filter(
                 (item, index, self) => self.findIndex(t => t.categoryName === item.categoryName) === index
            );

        if (result.length > 0) {
            this.loadimageList(1, '', this.distinctCatList[0].categoryId)
            this.activeItem = this.distinctCatList[0]
            this.selectedCategoryId = this.distinctCatList[0].categoryId
        }
      })
  }
  loadimageList(
    pageNumber: number,
    sortbydirection: string,
    categoryId: string,
  ) {
      if (categoryId === "")
      {
          this.docservice
              .documentList({
                  patientId: sessionStorage.getItem('ptId'),
                  emrpracticeId: localStorage.getItem('EmrPracticeId'),
                  pageNumber: pageNumber,
                  searchText: this.txtSearch
              })
              .subscribe((result) => {
                  this.arrdocdetails = result;
                

                  ///console.log(result);
                  this.rows = this.arrdocdetails.pageSize
              })


      }
      else {
          this.docservice
              .documentCatList({
                  patientId: sessionStorage.getItem('ptId'),
                  emrpracticeId: localStorage.getItem('EmrPracticeId'),
                  pageNumber: pageNumber,
                  category: categoryId,
                  searchText: this.txtSearch
              })
              .subscribe((result) => {
                  this.arrdocdetails = result

                  ///console.log(result);
                  this.rows = this.arrdocdetails.pageSize
              })
      }
  }
    Setitem(cat) {
        this.first = 0;
    this.loadimageList(1, '', cat.categoryId)
    this.selectedCategoryId = cat.categoryId
  }

  getdocumnetdetails(obj) {}


  formatdatetime(item, type) {
    if (item != null && type.indexOf('Date') > -1) {
      return this.datePipe.transform(item, environment.datetimeformat)
    }
    return item
  }

  viewDoc(rowData: any) {
    this.docservice
      .documentDetail({
        Id: rowData.fileName,
        Description: rowData.description,
        DBIndic: rowData.databaseIndic,
        fileFormat: rowData.format,
        DocumentType: rowData.documentType,
        Location: rowData.location,
        VisitDate: rowData.visitDate,
        PracticeId: localStorage.getItem('EmrPracticeId'),
          PatientId: this.selectedPatientService.getPatientValue().patientId,
      }).pipe(timeoutWith(10 * 1000, this.docservice
          .documentDetail({
              Id: rowData.fileName,
              Description: rowData.description,
              DBIndic: rowData.databaseIndic,
              fileFormat: rowData.format,
              DocumentType: rowData.documentType,
              Location: rowData.location,
              VisitDate: rowData.visitDate,
              PracticeId: localStorage.getItem('EmrPracticeId'),
              PatientId: this.selectedPatientService.getPatientValue().patientId,
          })))
      .subscribe(
        (documentDetails) => {
          this.docservice
            .documentGetDocuments({
              fn: documentDetails.docName,
              PatientName: sessionStorage.getItem('ptName'),
            })
            .subscribe(
              (file) => {
                if (documentDetails.flexPaper) {
                  this.router.navigate(['show-pdf'], {
                    relativeTo: this.activatedRoute,
                    state: {
                        pdf: file,
                        showPrintButton: this.setPrintFlag,//                       CareFinitySession.practiceSettings.enablePatientDemographicPrint,
                        enabledDocumentDownloads: this.enableDownloads
                      },
                  })
                } else {
                  const binaryData = [file]
                  const downloadLink = document.createElement('a')
                  downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: file.type }),
                  )
                  downloadLink.target = '_blank'
                  downloadLink.setAttribute('inline', 'arshid')
                  document.body.appendChild(downloadLink)
                  downloadLink.click()
                  document.body.removeChild(downloadLink) // Clean up
                }
              },
              (err) => {
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: 'ERROR',
                  detail:
                    'Document File missing, Please Contact Technical Support',
                })
              },
            )

          console.log(documentDetails)
        },
        (err) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: 'Document File missing, Please Contact Technical Support',
          })
        },
      )
  }
    back() {
        this.router.navigate(["/Patient/documents/catlist"])
    }


    SearchDocumentDetails() {
        // this.distinctCatList = null;

       // this.activeItem = null;

        this.arrdocdetails = null;
 
        this.rows = null
        this.LoaddistinctImageList();
    }

    clearSearch() {
        if (this.txtSearch.length >= 0 || this.txtSearch == '') {
            this.txtSearch = ''
            this.LoaddistinctImageList();
        }
    }


    otherColumsInfoView() {
        if (this.isSearchEnable) {
            this.isSearchEnable = false
        } else {
            this.isSearchEnable = true
        }
    }

    getLabelAndCount(item) {


       return  getLabelAndCount(item, this.distinctCatList)
  
    }
}
